const setData = (name, value, element) => element.dataset[name] = value;
const getData = (name, element) => element.dataset[name];

const STATUS_OPEN = 'open';
const STATUS_CLOSE = 'closed';

const property = 'hamburger';
const setHamburger = (value, element) => setData(property, value, element);
const state = (element) => getData(property, element);
const open = (element) => setHamburger(STATUS_OPEN, element);
const close = (element) => setHamburger(STATUS_CLOSE, element);

export const EVENT_OPEN = 'hamburger.open';
export const EVENT_CLOSE = 'hamburger.close';

const eventOpen = new CustomEvent(EVENT_OPEN, { cancelable: true });
const eventClose = new CustomEvent(EVENT_CLOSE, { cancelable: true });
const triggerOpen = (element) => element.dispatchEvent(eventOpen);
const triggerClose = (element) => element.dispatchEvent(eventClose);

export default class Hamburger {
	constructor(selectorOrElement) {
		let element = null;

		if (typeof selectorOrElement === 'string')
			element = document.querySelector(selectorOrElement);
		else if (selectorOrElement instanceof HTMLElement)
			element = selectorOrElement;

		this.element = element;
	}

	close() {
		close(this.element);
		triggerClose(this.element);
	}

	open() {
		open(this.element);
		triggerOpen(this.element);
	}

	get state() {
		return state(this.element);
	}

	toggle(onOpen, onClose) {
		if(!this.element) return;

		if (onOpen)
			(this.element).addEventListener(EVENT_OPEN, () => onOpen());
		if (onClose)
			(this.element).addEventListener(EVENT_CLOSE, () => onClose());

		(this.element).addEventListener('click', () =>
			(this.state === STATUS_OPEN) ? this.close() : this.open()
		);
	}
}
